// reducers.js
import {FETCH_LATEST_VERSION} from '../actions';
import {SET_LATEST_VERSION} from "../actions";
// import {SET_LATEST_VERSION} from "./actionTypes";

const initialState = {
    latestVersion: null,
    isLoading: false,
    error: null,
};

const versionReducer = (state = initialState, action) => {

    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_LATEST_VERSION:
            return {
                ...state,
            };

        case SET_LATEST_VERSION:
            return {
                ...state,
                latestVersion: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default versionReducer;
